module.exports = __webpack_public_path__ + "assets/img/蘑菇小兵.41050b0b.png";